import {Icons} from 'appearance'
import PaymentTypes from 'screens/Settings/Payments/PaymentTypes'
import PaymentsList from 'screens/Settings/Payments/PaymentsList'
import Subscriptions from 'screens/Settings/Payments/Subscription/Subscriptions'

export const settings = {
    users: [
        'firstname',
        'lastname',
        'email',
        'phone',
        'id',
        'address',
        'Insurance_org_Code',
    ],
    accounts: [],
    payments: ['paymentsList', 'subscriptions', 'paymentTypes'],
    crms: [],
}

export const components = {
    payments: {
        paymentTypes: PaymentTypes,
        subscriptions: Subscriptions,
        paymentsList: PaymentsList,
    },
}

export const icons = {
    subscriptions: Icons.Subscriptions,
    paymentTypes: Icons.PaymentTypes,
    paymentsList: Icons.Subscriptions,
}
